// Pure data — no icon/i18n imports. This module is safe to pull into the
// tiny CDN loader bundle (src/entry-loader.ts) to default-merge a sparse
// remote config before rendering, without dragging lucide-react or i18n
// locale data along with it (see scripts/check-bundles.mjs's loader budget).
import type { WidgetConfig } from "../types/widget";

export const defaultConfig: WidgetConfig = {
  status: {
    mobile: true,
    desktop: true,
  },
  iconId: "default",
  iconSize: 48,
  label: "Accessibility widget",
  heading: "Accessibility menu",
  position: {
    mobile: "bottom-right",
    desktop: "bottom-right",
  },
  language: {
    default: "en",
    selected: [],
  },
  margins: {
    desktop: {
      top: 20,
      bottom: 20,
      left: 20,
      right: 20,
    },
    mobile: {
      top: 20,
      bottom: 20,
      left: 20,
      right: 20,
    },
  },
  primaryColor: "#1863DC",
  keyboard: {
    enabled: false,
    shortcut: 'alt+a',
  },
  modules: {
    color: {
      darkContrast: { enabled: true },
      lightContrast: { enabled: true },
      highContrast: { enabled: true },
      highSaturation: { enabled: true },
      lowSaturation: { enabled: true },
      monochrome: { enabled: true },
    },
    content: {
      adjustFontSizing: { enabled: true },
      highlightTitle: { enabled: true },
      highlightLinks: { enabled: true },
      dyslexicFont: { enabled: true },
      letterSpacing: { enabled: true },
      lineHeight: { enabled: true },
      fontWeight: { enabled: true },
      textAlign: { enabled: true },
    },
    navigation: {
      readingGuide: { enabled: true },
      pauseAnimations: { enabled: true },
      bigCursor: { enabled: true },
    },
    statement: {
      enabled: false,
      url: "",
    },
    profiles: {
      enabled: true,
      lowVision: { enabled: true },
      adhd: { enabled: true },
      seizureSafe: { enabled: true },
      epilepsySafe: { enabled: true },
    },
    pageRead: {
      enabled: true,
    },
    muteSounds: {
      enabled: true,
    },
  },
};
